<template>
	<div>
		<!-- 网站索引数据 -->
		<clientModule class="indexData" moduletitle="网站访问轨迹">
			<div slot="moduletitle">
				网站访问轨迹
				<!-- 网址切换 -->
				<sky-dropdown-select
					class="site-list"
					@change="changeSite"
					v-model="siteId"
					:options="websiteList"
					:props="{ label: 'name', value: 'id' }"
				></sky-dropdown-select>
			</div>
		</clientModule>
		<div class="access-record-Select">
			<crm-filter-panel
				:groups="groups"
				label-width="100px"
				@search="filterChange"
			></crm-filter-panel>
			<!--   -->
		</div>
		<div class="access-record-Page">
			<el-row class="page-Title" style="padding: 0px 25px">
				<el-col :span="12">
					<p>
						系统将同一天内、来自同一来源的IP地址的多次访问合并为一个统计项，可点击展开查看当日访问详情。
						<el-tooltip
							effect="dark"
							content="目前仅支持配置GA的网站，访问数据直接来自GA。"
							placement="top"
						>
							<ig-icon name="tishi" style="font-size: 12px"></ig-icon>
						</el-tooltip>
					</p>
				</el-col>
				<el-col :span="12" style="text-align: right">
					<span>
						<el-checkbox v-model="checkboxData" @change="checkboxChange">仅看有线索</el-checkbox>
					</span>
					<el-button
						style="margin-left: 10px; margin-bottom: 10px"
						type="primary"
						@click="exportData"
						>导出数据</el-button
					>
				</el-col>
			</el-row>
			<el-row class="access-record-List">
				<el-col>
					<data-list
						:default-sort="{ prop: 'createTime', order: 'descending' }"
						:table-style="{ name: 'webclient' }"
						:data="data"
						:columns="columns"
						:loading="loading"
						size="big"
						align="left"
						:page="page"
						:page-size="page.pageSize"
						@page-size-changed="pageSizeChanged"
						@page-changed="pageChanged"
						@sort-change="sortChange"
					></data-list>
				</el-col>
			</el-row>
		</div>
		<el-dialog
			:title="Title"
			:visible.sync="dialogVisible"
			:width="Title == popup['Inquiry'] ? '1000px' : '500px'"
		>
			<div v-show="Title == popup['Inquiry']" v-loading="dialogloading">
				<div style="margin-bottom: 10px">共关联{{ total }}条线索/客户，你有权限查看{{ num }}条</div>
				<data-list
					:default-sort="{ prop: 'createTime', order: 'descending' }"
					:table-style="{ name: 'webclient' }"
					:data="inquiryCustomerVos"
					:columns="inquirycolumns"
					:loading="Dloading"
					size="big"
					align="left"
				></data-list>
			</div>
			<div v-show="Title == popup['Defended']">
				<div style="margin-bottom: 20px">
					<span>
						IP(
						<b>{{ IP }}</b>
						)已于{{ Time }}开启广告防御
					</span>
				</div>
				<div style="text-align: right">
					<el-button size="small" @click="cancel">取消</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import checkAllIpBlack from './components/checkAllIpBlack.vue';
import clientModule from '@/components/client/clientModule/clientModule';
import crmFilterPanel from '@/components/crm/crm-filterPanel.vue';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';
import { mapGetters } from 'vuex';
import { getWebsiteByCustomer } from '@/backend/services/account/service';
import ChildDataList from '@/components/iglobalwin/dataList/childDataList.vue';
import jumpLink from '@/components/website/jumpLink';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import accessrecord from '@/backend/services/accessrecord/accessrecord.js';
import { download2, getDateRegion } from '@/common/util.js';
function createFangwenyeshuValue(min, max) {
	return JSON.stringify({
		fromPageNum: min,
		toPageNum: max,
	});
}
function convertFangwenyeshuBodyParams(data) {
	if (!data.fangwenyeshu) {
		return null;
	}
	return JSON.parse(data.fangwenyeshu);
}
const list = listPageCreate({
	searchConfig: {
		// api: api.keywordRanking.keyword,
		api: api.accessrecord.getaccessrecordPage,
		method: 'POST',
	},
	setExtension: self => {
		let { siteId } = self;
		return {
			PathParam: {
				serviceSiteId: siteId,
			},
		};
	},
	getQuery(data, that) {
		let body = {
			ip: that.ipAddress,
			...data,
			...convertFangwenyeshuBodyParams(data),
			hasRelated: that.hasRelated,
			beginTimeStr: that.groups.others[4].value[0],
			endTimeStr: that.groups.others[4].value[1],
		};
		delete body.fangwenyeshu;
		that.queryData = body;
		return _.assign({}, body);
	},
});
export default {
	data() {
		let that = this;
		return {
			websiteList: [],
			siteId: '',
			domain: '',
			hasRelated: '0',
			IP: '',
			Time: '',
			SelectedObj: [],
			isLoad: false,
			ChackAll: [],
			popup: {
				Inquiry: '',
				Undefended: 'IP未防御：加入防御列表',
				Defended: 'IP防御详情',
			},
			Title: '',
			checkboxData: 0,
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: 'IP地址',
						label: 'IP地址',
						inputTitle: 'IP地址',
						clearable: true,
						prop: 'ip',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '设备',
						label: '设备',
						inputTitle: '设备',
						prop: 'equipmentType',
						value: '',
						options: [
							{
								value: 'MAC',
								label: 'MAC',
							},
							{
								value: 'Android',
								label: 'Android',
							},
							{
								value: 'Windows',
								label: 'Windows',
							},
							{
								value: 'ios',
								label: 'IOS',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '访问页数',
						label: '访问页数',
						inputTitle: '访问页数',
						prop: 'fangwenyeshu',
						value: '',
						options: [
							{
								value: createFangwenyeshuValue(1, 1),
								label: '1页',
							},
							{
								value: createFangwenyeshuValue(2, 2),
								label: '2页',
							},
							{
								value: createFangwenyeshuValue(3, 5),
								label: '3-5页',
							},
							{
								value: createFangwenyeshuValue(6, 10),
								label: '6-10页',
							},
							{
								value: createFangwenyeshuValue(11, 15),
								label: '11-15页',
							},
							{
								value: createFangwenyeshuValue(16, 20),
								label: '16-20页',
							},
							{
								value: createFangwenyeshuValue(20, 999999),
								label: '20页以上',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '国家/地区',
						label: '国家/地区',
						inputTitle: '国家/地区',
						prop: 'country',
						value: '',
						props: {
							label: 'name',
							value: 'name',
						},
						clearable: true,
						options: this.getoptions,
					},
					{
						tagName: 'sky-date-picker-prepend',
						type: 'daterange',
						label: '日期',
						startPlaceholder: '开始日期',
						endPlaceholder: '结束日期',
						prop: ['beginTimeStr', 'endTimeStr'],
						value: ['', ''],
						col: 8,
						style: 'margin:10px 2px',
					},
				],
			},
			columns: [
				{
					label: '',
					type: 'tableExpand',
					tagName: ChildDataList,
					width: 60,
					custom: {},
					indexable: true,

					columns: [
						{
							label: '',
							bind: 'inquiryTime',
							width: '210',
						},
						{
							label: '',
							bind: 'inquiryPath',
							type: jumpLink,
						},
					],
					isShowHeader: false,
					getSubData: that.getSubData,
				},
				{
					bind: 'inquiryIp',
					label: 'IP地址',
					width: 120,
					// type:webDetail,
				},
				{
					label: '访问时间',
					bind: 'inquiryTime',
					sort: 'inquiryTime',
					content: '该IP首次访问您网站的时间',
					width: 120,
					showOverflowTooltip: true,
					options: [
						{
							label: '由远到近',
							value: 'asc',
							bind: 'asc',
						},
						{
							label: '由近到远',
							value: 'desc',
							bind: 'desc',
						},
					],
				},
				{
					bind: 'countryRegion',
					label: '国家/地区',
					width: 120,
				},
				{
					bind: 'inquirySource',
					label: '来源',
					type: jumpLink,
				},
				{
					label: '归因',
					bind: 'wbInquiryGaVisitorVOList',
					type: 'multiRowPopover',
					width: 120,
					content:
						'<div style="line-height:20px;">当归因中显示“无”或“未提供”时，有多种情况，除系统未识别以外，常见的情况有：</br></br>1、媒介中显示“无”：本身无媒介，如直接访问</br>2、广告系列显示“无”：表示非付费广告</br>3、关键词显示“无”：广告系列为展示广告，无关键词</br>4、关键词显示“未提供”：搜索引擎出于隐私考虑，未提供自然搜索的关键词</div>',
					showOverflowTooltip: true,
					multiRowCon(val, row) {
						switch (row.identifiedStatus) {
							case 0:
								return '识别中';
							case 1:
								return '未匹配到归因信息';
						}
						if (row.wbInquiryGaVisitorVOList) {
							return row.wbInquiryGaVisitorVOList[0].source;
						}
					},
					disabled(row) {
						if (row.identifiedStatus !== 2) {
							return true;
						} else {
							return false;
						}
					},
					dialogList(val, row) {
						if (!row) return [];
						if (row) {
							let list = row.wbInquiryGaVisitorVOList.map((item, index) => {
								return [
									{
										label: `归因${index + 1}`,
										value: '',
									},
									{
										label: '来源/媒介：',
										value: item.source || '-',
									},
									{
										label: '广告系列：',
										value: item.adSeries || '-',
									},
									{
										label: '关键字：',
										value: item.keyword || '-',
									},
								];
							});
							let dialoglist = [];
							list.forEach(element => {
								element.forEach(item => {
									dialoglist.push(item);
								});
							});
							return dialoglist;
						} else {
							return [];
						}
					},
				},
				{
					bind: 'inquiryDevice',
					label: '设备',
					width: 120,
				},
				{
					label: '访问页数',
					bind: 'pvCount',
					sort: 'pvCount',
					width: 120,
					options: [
						{
							label: '由小到大',
							value: 'asc',
						},
						{
							label: '由大到小',
							value: 'desc',
						},
					],
				},
				{
					label: '操作',
					type: 'btnClick',
					content:
						'单个广告系列IP防御列表上限为500个，超出上限后再添加IP，系统将自动移除威胁程度最低的IP。',
					showOverflowTooltip: true,
					align: 'left',
					width: 200,
					style: 'text',
					bind() {
						let arr = [
							{
								text: '查看详情',
								trigger(row) {
									that.getClueDetail(row);
								},
								showButton({ inquiryIds }) {
									if (inquiryIds) {
										return true;
									} else {
										return false;
									}
								},
							},
							{
								text: 'IP已防御',
								trigger(row) {
									that.dialogloading = true;
									that.toDefense(row);
								},
								showButton({ isDefense }) {
									if (isDefense) {
										return true;
									} else {
										return false;
									}
								},
							},
						];

						return arr;
					},
				},
			],
			inquirycolumns: [
				{
					bind: 'type',
					label: '类型',
					type: 'mapping',
					mapType: 'text',
					parentEvent: (val, row) => {
						let type = [
							{ label: '线索', value1: 0, value2: 0 },
							{ label: '垃圾线索', value1: 0, value2: 1 },
							{ label: '客户', value1: 1, value2: 0 },
							{ label: '公海客户', value1: 1, value2: 1 },
						];
						if (row !== null) {
							return type.find(item => val == item.value1 && row.operationState == item.value2)
								.label;
						} else {
							return '-';
						}
					},
				},
				{
					label: '名称',
					text: [{ bind: 'name' }],
					type: 'custInfo',
				},
				{
					label: '内容',
					text: [{ bind: 'content' }],
					type: 'custInfo',
				},
				{
					label: '时间',
					text: [{ bind: 'submitTime' }],
					type: 'custInfo',
				},
			],
			inquiryCustomerVos: [],
			total: '',
			num: '',
			queryData: {},
			dialogVisible: false,
			inquiryData: {},
			Dloading: false,
			dialogloading: false,
			ipAddress: '',
			serviceSiteId: '',
		};
	},
	mixins: [list],
	components: {
		crmFilterPanel,
		skyDropdownSelect,
		clientModule,
		ChildDataList,
		jumpLink,
		checkAllIpBlack,
	},
	computed: {
		...mapGetters(['customerId', 'name']),
	},
	watch: {
		customerId: {
			handler(val) {
				if (val) this.getWebsite();
				else this.$message.warning('您需要先选择一个客户');
			},
			immediate: true,
			deep: true,
		},
		siteId: {
			handler(val) {
				if (val) {
					this.init(val);
				}
			},
		},
	},
	methods: {
		init(siteId) {
			if (!siteId) return;
			let date = getDateRegion('DAYS_30', 'YYYY-MM-DD', '&').split('&');
			this.groups.others[4].value = date;
			this.query();
		},
		// 网站下拉数据
		async getWebsite() {
			try {
				let { customerId } = this;
				let result = await getWebsiteByCustomer({
					customerId,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) {
					this.siteId = '';
					return false;
				}
				this.siteId = result.data[0].id;
				this.serviceSiteId = result.data[0].id;
				this.domain = result.data[0].name;
			} catch (error) {
				console.log(error);
			}
		},
		// 网址选择切换
		changeSite(id) {
			let obj = this.websiteList.find(item => {
				return item.id === id;
			});
			this.domain = obj.name;
		},
		checkboxChange(val) {
			if (val) {
				this.hasRelated = 1;
			} else {
				this.hasRelated = 0;
			}
			this.query();
		},
		// 导出数据
		async exportData() {
			try {
				if (!this.siteId) return;
				let res = await accessrecord.downloadwebsitevisit({ ...this.queryData }, this.siteId);
				if (res.data) {
					download2(res.data, `${this.name}访问轨迹.csv`);
				} else {
					this.$message.info('暂无数据');
				}
			} catch (error) {
				console.log(error);
				this.$message.info('暂无数据');
			}
		},
		async getoptions() {
			const countryOptions = await accessrecord.countryList();
			return countryOptions;
		},
		cancel() {
			this.dialogVisible = false;
		},
		async getClueDetail(row) {
			this.popup['Inquiry'] = row.inquiryIp;
			this.Title = this.popup['Inquiry'];
			this.dialogVisible = true;
			this.Dloading = true;
			const res = await accessrecord.getRecordInfo({ inquiryIds: row.inquiryIds });
			this.total = res.data.total;
			this.num = res.data.num;
			if (res) {
				this.Dloading = false;
				this.inquiryCustomerVos = res.data.inquiryCustomerVos;
			}
		},
		getCurrentNode(SelectedObj) {
			this.SelectedObj = SelectedObj;
		},
		toUnDefense(row) {
			this.IP = row.inquiryIp;
			this.dialogVisible = true;
			this.Title = this.popup['Undefended'];
		},
		toDefense(row) {
			this.IP = row.inquiryIp;
			this.Time = row.campaignEndTime;
			this.dialogVisible = true;
			this.Title = this.popup['Defended'];
		},
		async getSubData(row) {
			let param = {
				beginTimeStr: row.inquiryTime,
				ip: row.inquiryIp,
			};
			let res = await accessrecord.getRecordDetail(param, this.siteId);
			return res.data.data;
		},
	},
};
</script>
<style lang="scss" scoped>
.indexData {
	background-color: #fff;

	.site-list {
		margin-left: 20px;
	}

	.tab-style {
		padding: 15px 24px;
		box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		position: relative;

		::v-deep .el-tabs__nav-wrap {
			overflow: inherit;
		}

		::v-deep .el-tabs__nav-scroll {
			overflow: inherit;
		}

		::v-deep .el-tabs__active-bar {
			bottom: -14px;
		}
	}
}

.access-record-Select {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 4px;

	::v-deep .filterPanel {
		margin-bottom: 0px;
	}
}

.access-record-Page {
	background: #ffffff;
	// box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	border-radius: 0px;
	height: auto;

	.page-Title p {
		font-size: 15px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 40px;
	}
}
</style>
